var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "draggale-item",
      class: { "draggale-item-active": _vm.isSelected },
    },
    [
      !_vm.disabledDrag
        ? _c(
            "div",
            {
              staticClass: "draggable-handle",
              style: {
                background: _vm.item.color,
              },
            },
            [
              _c(
                "div",
                { staticClass: "draggable-handle__icon" },
                [
                  _c("SvgIcon", {
                    attrs: {
                      size: "14",
                      type: "mdi",
                      path: _vm.path.draggable,
                    },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _c("div", { staticClass: "draggale-item__info" }, [_vm._t("default")], 2),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }